import { extractQuizMetafields } from "./extract-quiz-fields";

// Quiz answers saved on the Shopify customer (custom.quiz_* fields), which the
// Zapier zap copies into NetSuite. Empty values are skipped by the backend, so
// a later save never blanks an earlier answer.
//
// outcome: what the visitor saw at the end of the quiz -
//   "quote_shown" | "renter" | "rooms_5_plus" | "large_home" | "needs_review"
export const buildQuizMetafields = ({
  answersMap = {},
  answers = [],
  postalCode,
  outcome,
  unrecognisedAnswer,
  quoteSummary,
} = {}) => {
  const tf = answersMap || {};
  const quizFields = extractQuizMetafields(tf, answers);

  const metafields = {
    quiz_postal_code_q: tf.postal_code_q || tf.postal_code || "",
    quiz_user_postal_code: postalCode || "",
    quiz_owner: tf.owner || "",
    quiz_home_type: tf.home_type || "",
    quiz_heat_source: tf.heat_source || "",
    quiz_heating_type: tf.heating_type || "",
    quiz_electric_panel: tf.electric_panel || "",
    quiz_system_age: tf.system_age || "",
    quiz_air_conditioner:
      typeof tf.air_conditioner !== "undefined" ? String(tf.air_conditioner) : "",
    quiz_sq_ft_central: tf["sq_ft-Central"] || tf.sq_ft || "",
    quiz_sq_ft_ductless: tf["sq_ft-Ductless"] || "",
    // Central path asks "condenser_position", ductless asks "condenser_mounted".
    quiz_condenser_mounted: tf.condenser_mounted || tf.condenser_position || "",
    quiz_room_number: tf.room_number || "",
    quiz_rooms_1_size: tf.rooms_1_size || "",
    quiz_utility: quizFields.quiz_utility,
    quiz_electrical_panel_size: quizFields.quiz_electrical_panel_size,
    quiz_outcome: outcome || "",
    quiz_unrecognised_answer: unrecognisedAnswer || "",
    // The three options and prices shown (see quote-summary.js)
    quiz_quote_summary: quoteSummary || "",
  };

  if (tf.room_number === "2") {
    metafields.quiz_rooms_2_size_room_1 = tf["rooms_2_size-room_1"] || "";
    metafields.quiz_rooms_2_size_room_2 = tf["rooms_2_size-room_2"] || "";
  } else if (tf.room_number === "3") {
    metafields.quiz_rooms_3_size_room_1 = tf["rooms_3_size-room_1"] || "";
    metafields.quiz_rooms_3_size_room_2 = tf["rooms_3_size-room_2"] || "";
    metafields.quiz_rooms_3_size_room_3 = tf["rooms_3_size-room_3"] || "";
  } else if (tf.room_number === "4") {
    metafields.quiz_rooms_4_size_room_1 = tf["rooms_4_size-room_1"] || "";
    metafields.quiz_rooms_4_size_room_2 = tf["rooms_4_size-room_2"] || "";
    metafields.quiz_rooms_4_size_room_3 = tf["rooms_4_size-room_3"] || "";
    metafields.quiz_rooms_4_size_room_4 = tf["rooms_4_size-room_4"] || "";
  }

  return metafields;
};
